var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileWithCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "67px",
    viewBox: "0 0 68 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrative-/-Bills-Illustrative-/-Mobile",
    transform: "translate(0.446154, 0.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9938999,55.9792329 L24.3469622,55.9792329 C23.0420325,55.9792329 21.9841653,54.9213658 21.9841653,53.6164361 L21.9841653,13.8781081 C21.9841653,12.5731784 23.0420325,11.5158347 24.3469622,11.5158347 L42.9938999,11.5158347 C44.2988296,11.5158347 45.3566968,12.5731784 45.3566968,13.8781081 L45.3566968,53.6164361 C45.3566968,54.9213658 44.2988296,55.9792329 42.9938999,55.9792329 Z M22.0088716,16.5795689 L45.332199,16.5795689 M22.0088716,46.5737433 L45.332199,46.5737433 M35.3171654,51.2324916 C35.3171654,52.142226 34.5801654,52.8792259 33.6704311,52.8792259 C32.7606967,52.8792259 32.0236968,52.142226 32.0236968,51.2324916 C32.0236968,50.3232807 32.7606967,49.5857573 33.6704311,49.5857573 C34.5801654,49.5857573 35.3171654,50.3232807 35.3171654,51.2324916 Z",
    id: "Icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWithCross);
export default __webpack_public_path__ + "static/media/mobile-with-cross.0c5d3d6d.svg";
export { ForwardRef as ReactComponent };